import { generateExampleNotePublic } from '@/pages/api/scribeAPIV2';
import { type GenerateExampleNotePublicResponse } from '@heidi/templates/contracts';
import { useMutation } from '@tanstack/react-query';

export const PUBLIC_EXAMPLE_NOTE_GENERATION_MUTATION_KEY = [
  'public-example-note-generation',
] as const;

interface PublicExampleNoteGenerationParams {
  transcript: string;
  templateStructure: string;
  specialtyName?: string;
  country?: string;
  language?: string;
  abbreviationsPreference?: boolean;
}

export function useMutationPublicExampleNoteGeneration() {
  return useMutation<
    GenerateExampleNotePublicResponse,
    Error,
    PublicExampleNoteGenerationParams
  >({
    mutationKey: PUBLIC_EXAMPLE_NOTE_GENERATION_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async ({
      transcript,
      templateStructure,
      specialtyName,
      country,
      language,
      abbreviationsPreference,
    }) => {
      const { data } = await generateExampleNotePublic({
        transcript,
        template_structure: templateStructure,
        specialty_name: specialtyName,
        country,
        language,
        abbreviations_preference: abbreviationsPreference,
      });
      return data;
    },
  });
}
